/* NSC SIDELINER – free personalised name lanyard (draft theme feature).
 * Modes (theme settings > "Sideliner lanyard offer"):
 *   off  – nothing renders
 *   demo – modal + cart row render, clearly labelled; NO cart requests are made
 *   live – adds the lanyard variant to the cart with property "Lanyard name",
 *          keeps lanyard qty <= chair qty and removes lanyards if the chair goes.
 * live with an empty variant ID falls back to demo (resolved in Liquid).
 */
(function () {
  'use strict';
  if (window.NSCSdlLanyard) return;

  var cfgEl = document.getElementById('nsc-sdl-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || cfg.mode === 'off') return;

  var MAX = cfg.maxLength || 14;
  var PROP = 'Lanyard name';
  var TO_FOLLOW = 'TO FOLLOW'; /* saved when the name is left blank (e.g. the chair is a gift) */
  var LIVE = cfg.mode === 'live' && !!cfg.variantId;
  var VARIANT_ID = LIVE ? parseInt(cfg.variantId, 10) : null;
  var origFetch = window.fetch.bind(window);
  var busy = false;
  var syncTimer = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function clean(v) {
    return String(v || '').toUpperCase().replace(/[^A-Z0-9 .'&\-]/g, '').replace(/\s{2,}/g, ' ').slice(0, MAX);
  }

  /* ---------- modal ---------- */
  var modal = document.getElementById('NscSdlLanyardModal');
  var input = modal && $('[data-nsc-sdl-input]', modal);
  var preview = modal && $('[data-nsc-sdl-preview]', modal);
  var counter = modal && $('[data-nsc-sdl-count]', modal);
  var addBtn = modal && $('[data-nsc-sdl-add]', modal);
  var msg = modal && $('[data-nsc-sdl-msg]', modal);
  var state = { action: 'add', key: null, qty: 1 };
  var lastFocus = null;

  function setMsg(text, kind) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.setAttribute('data-kind', kind || 'info');
  }
  function renderPreview() {
    if (!input) return;
    var v = clean(input.value);
    if (input.value !== v) input.value = v;
    preview.textContent = v.trim() ? v : 'YOUR NAME';
    preview.classList.toggle('is-empty', !v.trim());
    counter.textContent = v.length + '/' + MAX;
    addBtn.disabled = busy; /* name is optional */
  }
  function openModal(opts) {
    if (!modal) return;
    opts = opts || {};
    state.action = opts.action || 'add';
    state.key = opts.key || null;
    state.qty = opts.qty || 1;
    var pre = clean(opts.name || '').trim();
    input.value = pre === TO_FOLLOW ? '' : pre;
    setMsg('');
    $('[data-nsc-sdl-add-label]', modal).textContent = state.action === 'edit' ? 'Save lanyard name' : 'Add my free lanyard ($15 value)';
    renderPreview();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('nsc-sdl-modal-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); input.focus({ preventScroll: true }); });
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('nsc-sdl-modal-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- cart helpers (live mode only) ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionsToRender() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return (d.getSectionsToRender() || []).map(function (s) { return s.section; });
    }
    return [];
  }
  function isPreview() { return !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'); }
  function refreshUI(resp, open) {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; } /* cart page: drawer re-render doesn't touch the main cart list */
    if (isPreview()) { refreshSections(open); return; } /* POST section HTML comes from the published theme in previews */
    var d = drawer();
    if (d && resp && resp.sections && typeof d.renderContents === 'function') {
      try { d.renderContents(resp, !!open); return; } catch (e) { /* fall through */ }
    }
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  }
  function postJSON(url, body) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function tally(cart) {
    var chair = 0, lan = 0, lines = [];
    (cart.items || []).forEach(function (it) {
      if (it.handle === cfg.chairHandle) chair += it.quantity;
      if (VARIANT_ID && it.variant_id === VARIANT_ID) { lan += it.quantity; lines.push(it); }
    });
    return { chair: chair, lan: lan, lines: lines };
  }

  /* Keep lanyards <= chairs; remove all lanyards when no chair. */
  function sync() {
    if (!LIVE) return Promise.resolve();
    return getCart().then(function (cart) {
      var t = tally(cart);
      var excess = t.lan - t.chair;
      var ops = [];
      for (var i = t.lines.length - 1; i >= 0 && excess > 0; i--) {
        var line = t.lines[i];
        var take = Math.min(line.quantity, excess);
        excess -= take;
        ops.push({ key: line.key, quantity: line.quantity - take });
      }
      /* Lanyard lines with no "Lanyard name" property at all (e.g. added by URL): quietly set TO FOLLOW. Never blocks. */
      t.lines.forEach(function (line) {
        var has = line.properties && String(line.properties[PROP] || '').trim();
        var trimmed = ops.some(function (o) { return o.key === line.key; });
        if (!has && !trimmed) { var pr = {}; pr[PROP] = TO_FOLLOW; ops.push({ key: line.key, quantity: line.quantity, properties: pr }); }
      });
      if (!ops.length) return;
      var chain = Promise.resolve(), last = null;
      ops.forEach(function (op, idx) {
        chain = chain.then(function () {
          var body = { id: op.key, quantity: op.quantity };
          if (op.properties) body.properties = op.properties;
          if (idx === ops.length - 1) { body.sections = sectionsToRender(); body.sections_url = location.pathname; }
          return postJSON('/cart/change.js', body).then(function (r) { last = r; });
        });
      });
      return chain.then(function () { refreshUI(last, false); });
    }).catch(function (e) { if (window.console) console.warn('[NSC lanyard] sync failed', e); });
  }
  /* Re-render the drawer/cart sections with a GET when the gift row is out of step with the cart
     (e.g. theme previews, where POST section rendering can come from the published theme). Read-only. */
  function refreshSections(open) {
    var list = sectionsToRender();
    if (!list.length) return Promise.resolve();
    var url = location.pathname + '?sections=' + encodeURIComponent(list.join(','));
    if (isPreview()) url += '&preview_theme_id=' + Shopify.theme.id;
    return origFetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (sections) { var d = drawer(); if (d && typeof d.renderContents === 'function') d.renderContents({ sections: sections }, !!open); })
      .catch(function () {});
  }
  function ensureRow() {
    return getCart().then(function (cart) {
      var chair = 0;
      (cart.items || []).forEach(function (it) { if (it.handle === cfg.chairHandle) chair += it.quantity; });
      var body = document.getElementById('CartDrawer-Body');
      if (!body) return;
      var hasRow = !!body.querySelector('[data-nsc-sdl-row]');
      if ((chair > 0) !== hasRow) {
        var d = drawer();
        var isOpen = !!(d && d.classList.contains('is-visible'));
        return refreshSections(isOpen);
      }
    }).catch(function () {});
  }
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { sync().then(function () { setTimeout(ensureRow, 150); }); }, 350);
  }

  function submit() {
    var name = clean(input.value).trim() || TO_FOLLOW;
    if (!LIVE) {
      setMsg('Preview mode: a free lanyard with "' + name + '" would be added. Nothing was added to your cart.', 'demo');
      return;
    }
    busy = true; renderPreview();
    var props = {}; props[PROP] = name;
    var p;
    if (state.action === 'edit' && state.key) {
      p = postJSON('/cart/change.js', { id: state.key, quantity: state.qty, properties: props, sections: sectionsToRender(), sections_url: location.pathname });
    } else {
      p = getCart().then(function (cart) {
        var t = tally(cart);
        if (t.chair < 1) throw { description: 'Add a SIDELINER chair first – the lanyard comes free with it.' };
        if (t.lan >= t.chair) throw { description: 'You already have a free lanyard for each chair. You can edit the name in your cart.' };
        return postJSON('/cart/add.js', { items: [{ id: VARIANT_ID, quantity: 1, properties: props }], sections: sectionsToRender(), sections_url: location.pathname });
      });
    }
    p.then(function (resp) { closeModal(); refreshUI(resp, true); setTimeout(ensureRow, 300); })
      .catch(function (err) { setMsg((err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.', 'error'); })
      .then(function () { busy = false; renderPreview(); });
  }

  /* ---------- watch theme cart requests ---------- */
  function urlOf(input) { return typeof input === 'string' ? input : (input && input.url) || ''; }
  window.fetch = function (input, init) {
    var url = urlOf(input);
    var p = origFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) {
        if (!res || !res.ok) return;
        var isAdd = /\/cart\/add/.test(url);
        res.clone().json().then(function (data) {
          if (isAdd) {
            var items = data && data.items ? data.items : [data];
            var chairAdded = items.some(function (it) { return it && it.handle === cfg.chairHandle; });
            if (chairAdded) {
              if (LIVE) {
                getCart().then(function (cart) { var t = tally(cart); if (t.lan < t.chair) setTimeout(function () { openModal({ action: 'add' }); }, 500); });
              } else {
                setTimeout(function () { openModal({ action: 'add' }); }, 500);
              }
            }
          }
          scheduleSync();
        }).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-nsc-sdl-open]');
    if (t) {
      e.preventDefault();
      openModal({ action: t.getAttribute('data-nsc-sdl-open'), key: t.getAttribute('data-key'), name: t.getAttribute('data-name'), qty: parseInt(t.getAttribute('data-qty') || '1', 10) });
      return;
    }
    if (!modal || modal.hidden) return;
    if (e.target.closest('[data-nsc-sdl-close]')) { e.preventDefault(); closeModal(); return; }
    if (e.target.closest('[data-nsc-sdl-add]')) { e.preventDefault(); submit(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'Enter' && e.target === input) { e.preventDefault(); submit(); }
  });
  if (input) input.addEventListener('input', renderPreview);

  /* Initial clean-up in live mode (e.g. chair removed in another tab) */
  if (LIVE) sync();

  /* Preview hook for QA/screenshots: add #nsc-lanyard-preview to the URL */
  if (location.hash === '#nsc-lanyard-preview') setTimeout(function () { openModal({ action: 'add' }); }, 300);

  window.NSCSdlLanyard = { open: openModal, close: closeModal, sync: sync, mode: LIVE ? 'live' : 'demo' };
})();
